import { render, staticRenderFns } from "./v-file-chips.vue?vue&type=template&id=76fbc2ab&scoped=true"
import script from "./v-file-chips.vue?vue&type=script&lang=js"
export * from "./v-file-chips.vue?vue&type=script&lang=js"
import style0 from "./v-file-chips.vue?vue&type=style&index=0&id=76fbc2ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fbc2ab",
  null
  
)

export default component.exports